import { defineStore } from 'pinia'
import { queryBadgeData } from '@/api';


export const useReddotStore = defineStore('reddot', {
  // persist: true,
  state: () => {
    return {
      loginBonusRewardNum: 0, // 登录奖励
      inviteFriendToEarnNum: 0, // 邀请好友(大转盘)
      inboxUnread: 0, // 未读站内信
      taskRewardNum: 0, // 任务奖励
      // inviteFriendEnergy: 0, // 邀请好友(充能)
      // dailyDepositSign: 0, // 每日充值签到
      vipTabRedDot: false, // tabbar vip红点
      friendCardTabRedDot: false, // tabbar 好友卡红点
      // stepTaskNum: 0, // 步骤任务奖励
      rewardsRedDot: false,
    }
  },
  getters: {},
  actions: {
    fetchData(callback) {
      queryBadgeData().then(res => {
        let data = res.data || {};
        this.loginBonusRewardNum = data.loginBonusRewardNum;
        this.inviteFriendToEarnNum = data.inviteFriendToEarnNum;
        this.inboxUnread = data.letterUnreadNum;
        this.taskRewardNum = data.taskRewardNum;
        // this.inviteFriendEnergy = data.inviteFriendEnergy;
        // this.dailyDepositSign = data.dailyDepositSign;
        this.vipTabRedDot = data.vipCardDailyRedDot || data.vipCardTurnoverRedDot || data.vipCardMonthlyRedDot || data.letterGiftUnreadNum || false;
        this.friendCardTabRedDot = data.friendCardInviteRedDot || data.friendCardDepositRedDot || data.friendCardTurnoverRedDot || false;
        // this.stepTaskNum = data.stepTaskNum;
        this.rewardsRedDot = data.rewardsRedDot;
        callback && callback();
      });
    },
    set(key, value = 0) {
      this[key] = value;
    },
  }
})
